var React = require('react');

function Security (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.0001 37.7142C22.0001 37.7142 34.5716 31.4285 34.5716 21.9999V10.9999L22.0001 6.28564L9.42871 10.9999V21.9999C9.42871 31.4285 22.0001 37.7142 22.0001 37.7142Z","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Security.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Security;

Security.default = Security;
